/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const customRenderEnumSchema = z.enum(["swiper"]).describe("* `swiper` - swiper");
